// calc max height
function setMinHeght() {
  var boxes = document.querySelectorAll(".max-height-box");

  function calc(box) {
    box.forEach(function (item) {
      var title = item.querySelectorAll(".max-height-title");
      var height = 0;

      title.forEach(function (el) {
        el.style.minHeight = "";
        if (el.clientHeight > 0) height = el.clientHeight;
      });

      title.forEach(function (el) {
        if (window.screen.width > 768) {
          el.style.minHeight = height + "px";
        } else {
          el.style.minHeight = "";
        }
      });
    });
  }

  calc(boxes);

  window.addEventListener("resize", function () {
    calc(boxes);
  });
}

function setEqualHeightQuotes() {
  var boxes = document.querySelectorAll(".review__card");
  var height = 0;

  //if (window.screen.width > 768) {
  boxes.forEach(function (item) {
    item.style.height = "";

    if (item.offsetHeight > height) {
      height = item.offsetHeight;
    }
  });

  boxes.forEach(function (item) {
    item.style.height = height + "px";
  });
  // } else {
  //   boxes.forEach(function (item) {
  //     item.style.height = "";
  //   });
  // }
}

function cwsMenuFix() {
  var menu = document.querySelector(".grandparent>.main-menu-dropdown");
  var header = document.querySelector(".header-wrapper");
  var headerHeight = header.clientHeight;
  var megaDropdown = header.querySelector(".grandparent");
  var menuItem = megaDropdown.querySelector(".main-menu-dropdown");
  var menuItems = header.querySelectorAll(".main-menu>li");
  var timer;

  function hideMenu() {
    megaDropdown.classList.remove("is-hovered");
    menuItem.style.display = "none";
  }

  menu.style.top = headerHeight + "px";

  window.addEventListener("resize", function () {
    headerHeight = header.clientHeight;

    menu.style.top = headerHeight + "px";
  });

  megaDropdown.addEventListener("mouseenter", function () {
    megaDropdown.classList.add("is-hovered");
    menuItem.style.display = "block";
    clearInterval(timer);
  });

  megaDropdown.addEventListener("mouseleave", function () {
    timer = setInterval(function () {
      hideMenu();
      clearInterval(timer);
    }, 500);

    return timer;
  });

  menuItem.addEventListener("mouseenter", function () {
    clearInterval(timer);
  });

  menuItem.addEventListener("mouseleave", function () {
    hideMenu();
    clearInterval(timer);
  });

  menuItems.forEach(function (link) {
    link.addEventListener("mouseenter", function () {
      if (
        !link.classList.contains("grandparent") &&
        megaDropdown.classList.contains("is-hovered")
      ) {
        hideMenu();
        clearInterval(timer);
      }
    });
  });
}

function cwsMobileFix() {
  var body = document.body;
  var btnOpen = document.querySelector(".header__hamburger");
  var btnClose = document.querySelector(".touch__nav__close");
  var swicher = document.querySelector(".country-switcher-container");
  var swicherMobile = document.querySelector(".touch-menu__location");
  var headerTrial = document.querySelector(".header-trial");

  function moveSwicher() {
    if (window.screen.width < 768) {
      swicherMobile.append(swicher);
    } else {
      headerTrial.after(swicher);
    }
  }

  btnOpen.addEventListener("click", function () {
    body.classList.toggle("mm-visible");
  });

  btnClose.addEventListener("click", function () {
    body.classList.remove("mm-visible");
  });

  if (window.screen.width < 768) {
    swicherMobile.append(swicher);
  }

  window.addEventListener("resize", function () {
    if (window.screen.width < 768) {
      swicherMobile.append(swicher);
    } else {
      headerTrial.after(swicher);
    }
  });
}

// init functions
cwsMenuFix();
cwsMobileFix();
setMinHeght();
setEqualHeightQuotes();

// reinit function on resize
window.addEventListener("resize", setEqualHeightQuotes);
